import script from "./PropertyLegalTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyLegalTab.vue?vue&type=script&setup=true&lang=js"

import "./PropertyLegalTab.vue?vue&type=style&index=0&id=fecdaa80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fecdaa80"]])

export default __exports__